import React from "react"

import SetAxisRangeField from "./SetAxisRangeField"
import GraphFieldTable from "./GraphFieldTable"
import GraphInputField from "./GraphInputField"
import { registration } from "./index"
import { isHomeDashPlot } from "../../resources/utils"

export default function GraphEditForm({ intl, state, graphKey, dispatch, timeExtractor }) {
  const {
    title = "",
    axis1label = "",
    axis2label = "",
    axis1domain = [],
    axis2domain = [],
    xaxisdomain = [],
    observations = [],
    tags = [],
    microbes = [],
  } = state
  const { special = "" } = graphKey
  const editing_allowed = registration.editingAllowed(state)
  const disabled = !dispatch || !editing_allowed
  return (
    <div>
      <GraphInputField
        field={"title"}
        field_label={registration["title_label"](intl)}
        field_value={title}
        warning_label={registration["warn_required_field"](intl)}
        disabled={disabled || isHomeDashPlot(graphKey)} // on HomeDash there is a reliance on titles not changing for certain plots
        update_field={(val) => dispatch && dispatch({ type: "field", field: "title", value: val })}
      />
      {editing_allowed && (
        <>
          {(!disabled || axis1label) && (
            <GraphInputField
              field={"axis1label"}
              field_label={registration["y1_axis_label"](intl)}
              field_value={axis1label}
              warning_label={registration["warn_required_field"](intl)}
              disabled={disabled}
              update_field={(val) => dispatch && dispatch({ type: "field", field: "axis1label", value: val })}
            />
          )}
          {(!disabled || axis2label) && (
            <GraphInputField
              field={"axis2label"}
              field_label={registration["y2_axis_label"](intl)}
              field_value={axis2label}
              warning_label={registration["warn_required_field"](intl)}
              disabled={disabled}
              update_field={(val) => dispatch && dispatch({ type: "field", field: "axis2label", value: val })}
            />
          )}

          <div style={{ marginBottom: "10px", marginTop: "15px" }}>
            <b>
              <label>{registration["axes_ranges_label"](intl)}:</label>
            </b>
            <div className={"row"} style={{ margin: "0", marginBottom: "15px" }}>
              <SetAxisRangeField
                missing_value_alt={registration.missing_value_alt(intl)}
                axis_domain={axis1domain}
                label={`${registration["y_axis_label"](intl)}1`}
                min_label={registration["min_label"](intl)}
                max_label={registration["max_label"](intl)}
                update_field={(val) =>
                  dispatch &&
                  dispatch({
                    type: "field",
                    field: "axis1domain",
                    value: val,
                  })
                }
                disabled={disabled}
                numerical={true}
              />
              <SetAxisRangeField
                missing_value_alt={registration.missing_value_alt(intl)}
                axis_domain={axis2domain}
                label={`${registration["y_axis_label"](intl)}2`}
                min_label={registration["min_label"](intl)}
                max_label={registration["max_label"](intl)}
                update_field={(val) =>
                  dispatch &&
                  dispatch({
                    type: "field",
                    field: "axis2domain",
                    value: val,
                  })
                }
                disabled={disabled}
                numerical={true}
              />
              {/* Foundation for X-Axis Adjustments */}
              {timeExtractor && (
                <SetAxisRangeField
                  missing_value_alt={registration.missing_value_alt(intl)}
                  axis_domain={xaxisdomain}
                  label={registration["x_axis_label"](intl)}
                  min_label={registration["min_label"](intl)}
                  max_label={registration["max_label"](intl)}
                  update_field={(val) =>
                    dispatch &&
                    dispatch({
                      type: "field",
                      field: "xaxisdomain",
                      value: val,
                    })
                  }
                  disabled={disabled}
                  numerical={timeExtractor.name === "Day"}
                />
              )}
            </div>
          </div>
          {((observations.length > 0 && special !== "site-wide") ||
            (tags.length > 0 && special === "site-wide") ||
            (microbes.length > 0 && special === "microbial-community")) && (
            <div style={{ marginTop: "10px" }}>
              <b>
                <label>{registration["edit_graph_trends"](intl)}:</label>
              </b>
              <GraphFieldTable
                intl={intl}
                disabled={disabled}
                graph_value={
                  special === "microbial-community" ? microbes : special === "site-wide" ? tags : observations
                }
                update_field={(val, idx, field) =>
                  dispatch &&
                  dispatch({
                    type: "edit-list-entry",
                    field:
                      special === "microbial-community"
                        ? "microbes"
                        : special === "site-wide"
                          ? "tags"
                          : "observations",
                    index: idx,
                    list_field: field,
                    value: val,
                  })
                }
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}
